import { render, staticRenderFns } from "./TravelPolicy.vue?vue&type=template&id=62c2f1d4&scoped=true&"
import script from "./TravelPolicy.vue?vue&type=script&lang=js&"
export * from "./TravelPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TravelPolicy.vue?vue&type=style&index=0&id=62c2f1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2f1d4",
  null
  
)

export default component.exports